'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import {
  styled,
  Flex,
  $white,
  $fontWeightBolder,
  $fontSize,
  $fontWeightBold,
} from '@acko-tech/building-blocks.ui.common'
import { Text } from '@acko-tech/building-blocks.ui.typography'

export const BlogContainer = styled(Flex)`
  flex-direction: column;
  background: ${$white};
  border: 1px solid #e4eaf1;
  border-radius: 4px;
  padding: 32px 11px 25px 20px;
  box-sizing: border-box;
  margin-bottom: 20px;

  @media screen and (max-width: 426px) {
    display: none;
  }
`

export const BlogHeading = styled(Text)`
  font-weight: ${$fontWeightBolder};
  font-size: ${$fontSize.medium};
  line-height: 136.6%;
  letter-spacing: 0.02em;
  color: #5d607c;
  margin-bottom: 10px;
`

export const Subheading = styled(Text)`
  font-weight: ${$fontWeightBold};
  font-size: ${$fontSize.normal};
  line-height: 16px;
  margin-top: 10px;
  color: #8a99a9;
  letter-spacing: 0.01em;
  margin-bottom: 22px;
`

export const FormCTA = styled.a`
  display: flex;
  width: 100%;
  height: 50px;
  background: rgb(68, 203, 134);
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0px 6px;
  margin-top: 8px;
  font-weight: 600;
  outline: none;
  font-size: 16px;
  color: #ffffff;
  box-sizing: border-box;
  max-width: 151px;
  margin-right: 10px;
`

export const ImageLink = styled.a`
  margin-top: 8px;
  cursor: pointer;
  margin-right: 10px;
`
